import { render, staticRenderFns } from "./CoursePurchase.vue?vue&type=template&id=3a7dcb18&scoped=true&"
import script from "./CoursePurchase.vue?vue&type=script&lang=js&"
export * from "./CoursePurchase.vue?vue&type=script&lang=js&"
import style0 from "./CoursePurchase.vue?vue&type=style&index=0&id=3a7dcb18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7dcb18",
  null
  
)

export default component.exports